<template>
    <div v-if="isVisible" class="h2 mb-0 d-flex justify-content-start align-items-center">
      <div class="spinner-border" style="width: 20px; height: 20px;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </template>

  <script>


  export default {
    name: "WidgetsCustomSkeleton",
    props: {
      isVisible: {
        type: Boolean,
        default: true
      }
    }
  };
  </script>